/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-console */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import WeightCollectedIcon from "../../../Common/Svgs/WeightCollectedIcon";
import WeightDeliveredIcon from "../../../Common/Svgs/WeightDeliveredIcon";
import SpoiltMilkIcon from "../../../Common/Svgs/SpoiltMilkIcon";
import { updateTrips } from "../../../Redux/Slices/trips.slice";
import FarmerBadge from "./FarmerBadge";
import ArrowIcon from "../../../Common/Svgs/ArrowIcon";
import ViewReceiptModal from "./ViewReceiptModal";
import ToastMessageModal from "../ToastMessageModal";
import EditIcon from "../../../Common/Svgs/EditIcon";
import { getStopSummary } from "../../../Redux/APIs/tripsAPI";
import TrashIcon from "../../../Common/Svgs/TrashIcon";
import DeleteFarmerActivityModal from "./DeleteFarmerActivityModal";
import { InfoCircleSecondaryIcon } from "../../../Common/Svgs/InfoCircleIcon";
import EditedWeightModal from "./EditedWeightModal";

const Listings = ({
  icon,
  title,
  value,
  unit = "per kg",
  isEdited = false,
  onOpenEditedWeightModal = null,
}) => {
  const localUnit = unit?.split(" ")?.[1] || "kg";

  return (
    <div className="flex items-center justify-between my-2">
      <div className="flex items-center gap-x-2">
        {icon}
        <p className="font-aileron text-sm font-normal text-grey-200">
          {title}
        </p>
      </div>
      <div className="flex items-center gap-1.5">
        <p className="font-aileron text-sm font-semibold">
          {value} <span className="capitalize">{localUnit}</span>
        </p>
        {isEdited ? (
          <button
            type="button"
            className="flex items-center gap-1 cursor-pointer focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              onOpenEditedWeightModal?.();
            }}
          >
            <span className="font-aileron text-xs font-semibold text-yellow-dark hover:underline">
              (Edited)
            </span>
            <InfoCircleSecondaryIcon
              bgColor="#EAB726"
              fillColor="#ffffff"
              className="flex items-center"
            />
          </button>
        ) : null}
      </div>
    </div>
  );
};

const FarmerCard = ({
  index,
  isOrigin = 0,
  isDestination = 0,
  farmerId,
  farmerName,
  farmerStop = 0,
  isNewFarmer = 0,
  farmerStopName,
  activities = [],
  agriDelivery = null,
  onOpenEditedWeightModal = null,
}) => {
  const { id, stopId } = useParams();

  const stopMetaDataFromOverallSummary = activities[0]?.metaData;

  const showReceiptData =
    activities[0]?.type === 2 &&
    stopMetaDataFromOverallSummary &&
    Object.keys(stopMetaDataFromOverallSummary).length > 0;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const receiptStatus = activities[0]?.metaData?.receiptStatus;

  const getBadge = () => {
    if (isNewFarmer) {
      return (
        <div className="mt-4 mb-4">
          <FarmerBadge type={1} text="New Entry" />
        </div>
      );
    }
    if (!isNewFarmer && farmerStop) {
      return (
        <div className="mt-4 mb-4">
          <FarmerBadge
            type={2}
            text={`Farmer originally from stop ${farmerStopName}`}
          />
        </div>
      );
    }
    return <></>;
  };

  const onEditClick = (e, item) => {
    e.stopPropagation();

    dispatch(
      updateTrips({
        key: "editProduceModal",
        value: {
          visible: true,
          data: {
            produceId: item?.produceId || 0,
            produceName: item?.produce || "",
            farmerId: farmerId || 0,
          },
        },
      }),
    );
  };

  const onDeleteClick = (e) => {
    e.stopPropagation();

    dispatch(
      updateTrips({
        key: "deleteFarmerActivityModal",
        value: { visible: true, data: { farmerId, farmerName } },
      }),
    );
  };

  return (
    <div
      className="p-4 rounded-2xl border border-light-grey"
      style={{ width: "49.3%" }}
      role={!isOrigin && !isDestination && "button"}
      onClick={() => {
        if (!isOrigin && !isDestination) {
          dispatch(
            updateTrips({
              key: "currentFarmer",
              value: {
                id: farmerId,
                name: farmerName,
                index,
                farmerStop,
                farmerStopName,
                isNewFarmer,
              },
            }),
          );

          navigate(`/trips/${id}/${stopId}/${farmerId}`);
        }
      }}
    >
      <div className="pb-4 border-b border-[#E7E7E7]">
        {!isOrigin && !isDestination && (
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-x-2">
              <div className="w-6 h-6 bg-[#E7E7E7] rounded-full flex items-center justify-center">
                <p className="font-poppins text-xs font-semibold">
                  {index + 1}
                </p>
              </div>

              <p className="font-poppins text-base font-medium capitalize">
                {isDestination ? "Destination Delivery" : farmerName}
              </p>
            </div>

            <div className="flex items-center gap-x-2">
              {activities?.length > 0 && (
                <div role="button" onClick={onDeleteClick}>
                  <TrashIcon size={20} className="text-alert-red" />
                </div>
              )}

              <ChevronIcon className="w-5 h-5 stroke-grey-200" />
            </div>
          </div>
        )}

        <div className="flex items-center gap-2 mt-0">
          {!isOrigin && !isDestination && getBadge()}
          {showReceiptData && (
            <div
              className={`py-0.5 px-2  rounded max-w-max ${
                receiptStatus === 0 ? "bg-alert-red" : "bg-green"
              }`}
            >
              <p className="font-poppins text-xs font-normal text-background-white">
                {receiptStatus === 0
                  ? "Verification Pending"
                  : "Receipt Verified"}
              </p>
            </div>
          )}
        </div>
      </div>

      {activities.map((item, mapIndex) => (
        <div
          key={item.activityId || mapIndex}
          className={`mt-4 ${
            mapIndex !== 0 && "pt-4 border-t border-[#E7E7E7]"
          }`}
        >
          <div className="flex items-center justify-between">
            <div
              role="button"
              className="flex items-center gap-x-2"
              onClick={(e) => onEditClick(e, item)}
            >
              <div>
                <EditIcon />
              </div>

              <p className="font-poppins text-sm font-medium capitalize">
                {item.produce}
              </p>
            </div>

            <button
              type="button"
              className="flex items-center gap-x-1 font-aileron text-xs font-semibold text-grey-200"
              onClick={(e) => {
                e.stopPropagation();
                dispatch(
                  updateTrips({
                    key: "editCommodityModal",
                    value: {
                      visible: true,
                      data: [
                        {
                          ...item,
                          tripId: +id,
                          stopId: +stopId,
                          farmerId: +farmerId,
                          activityType: item.type || item.activityType || 2,
                        },
                      ],
                    },
                  }),
                );
              }}
            >
              <EditIcon />
              <span>Edit Weight</span>
            </button>
          </div>
          {item.weightCollected && !item.isDestination ? (
            <Listings
              icon={<WeightCollectedIcon />}
              title="Total collected"
              value={item.weightCollected}
              unit={item?.unit}
              isEdited={+item.isEdited === 1}
              onOpenEditedWeightModal={() => onOpenEditedWeightModal?.(item)}
            />
          ) : null}
          {item.weightDelivered && !item.isOrigin ? (
            <>
              <Listings
                icon={<WeightDeliveredIcon />}
                title="Total delivered"
                value={item.weightDelivered}
                unit={item?.unit}
                isEdited={+item.isEdited === 1}
                onOpenEditedWeightModal={() => onOpenEditedWeightModal?.(item)}
              />
              {showReceiptData && (
                <button
                  className="w-full flex bg-primary-10 rounded-md p-4 justify-between border-primary border-[1px]"
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();

                    dispatch(
                      updateTrips({
                        key: "receiptModal",
                        value: {
                          visible: true,
                          data: activities[0],
                        },
                      }),
                    );
                  }}
                >
                  <div className="flex">
                    <img
                      src={stopMetaDataFromOverallSummary?.receiptUrl}
                      className="h-[50px] w-[50px] rounded-4 mr-[14.5px]"
                      alt="receipt preview"
                    />
                    {stopMetaDataFromOverallSummary?.receiptStatus ? (
                      <div className="flex flex-col items-start">
                        <p className="font-poppins font-medium text-sm text-black">
                          Receipt Verified
                        </p>
                        <p className="font-aileron font-normal text-xs">
                          {stopMetaDataFromOverallSummary?.receiptId}
                        </p>
                      </div>
                    ) : (
                      <p className="flex items-center font-poppins font-medium text-sm">
                        View Receipt
                      </p>
                    )}
                  </div>
                  <div className="rotate-90 pt-4">
                    <ArrowIcon />
                  </div>
                </button>
              )}
            </>
          ) : null}
          {item.spoiltMilk ? (
            <Listings
              icon={<SpoiltMilkIcon />}
              title="Spoilt milk"
              value={item.spoiltMilk}
              unit="per litre"
            />
          ) : null}
        </div>
      ))}

      {agriDelivery && (
        <div
          className={`mt-4 ${
            activities?.length ? "pt-4 border-t border-[#E7E7E7]" : ""
          }`}
        >
          <div className="flex items-center justify-between mb-2">
            <p className="font-poppins text-sm font-medium capitalize">
              Feed Delivery
            </p>
          </div>

          <div className="flex items-center justify-between my-2">
            <p className="font-aileron text-xs font-normal text-grey-200">
              Type of produce
            </p>
            <p className="font-aileron text-xs font-semibold capitalize">
              {agriDelivery.produce || "Feed"}
            </p>
          </div>

          <div className="flex items-center justify-between my-2">
            <p className="font-aileron text-xs font-normal text-grey-200">
              Delivery fee
            </p>
            <p className="font-aileron text-xs font-semibold">
              {(
                agriDelivery.delivery_price ||
                agriDelivery.deliveryPrice ||
                "100 Ksh"
              )
                .toString()
                .includes("Ksh")
                ? agriDelivery.delivery_price || agriDelivery.deliveryPrice
                : `${
                    agriDelivery.delivery_price ||
                    agriDelivery.deliveryPrice ||
                    "100"
                  } Ksh`}
            </p>
          </div>

          <div className="flex items-center justify-between my-2">
            <p className="font-aileron text-xs font-normal text-grey-200">
              M-Pesa number
            </p>
            <p className="font-aileron text-xs font-semibold">
              {agriDelivery.mpesa_transaction_no ||
                agriDelivery.mpesaTransactionNo ||
                "--"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

const StopSummary = () => {
  const dispatch = useDispatch();

  const {
    currentStop,
    stopSummary,
    overallSummaryForTrip,
    toastMessage,
    receiptModal,
    deleteFarmerActivityModal,
  } = useSelector((state) => state.trips);

  const [editedWeightModal, setEditedWeightModal] = useState({
    visible: false,
    data: null,
  });

  const combinedStopSummary = React.useMemo(() => {
    const list = [...(stopSummary || [])];
    const agriDeliveries = overallSummaryForTrip?.agriDeliveries || [];

    if (!agriDeliveries.length || !currentStop?.stopId) {
      return list;
    }

    const stopIdNum = Number(currentStop.stopId);
    const stopAgriDeliveries = agriDeliveries.filter(
      (del) =>
        Number(del.stop_id || del.stopId) === stopIdNum &&
        (Number(del.status) === 2 ||
          del.mpesa_transaction_no ||
          del.mpesaTransactionNo),
    );

    stopAgriDeliveries.forEach((del) => {
      const farmerId = del.farmer_id || del.farmerId;
      const existingIndex = list.findIndex(
        (f) => Number(f.farmerId) === Number(farmerId),
      );

      const fName =
        del.farmerName ||
        del.farmer_name ||
        `${del.farmer_first_name || del.farmerFirstName || ""} ${
          del.farmer_last_name || del.farmerLastName || ""
        }`.trim() ||
        "Farmer";

      if (existingIndex !== -1) {
        list[existingIndex] = {
          ...list[existingIndex],
          agriDelivery: del,
        };
      } else {
        list.push({
          tripId: del.trip_id || del.tripId,
          stopId: del.stop_id || del.stopId,
          farmerId,
          farmerName: fName,
          farmerContactNo: del.contact_no || del.contactNumber || "",
          isOrigin: 0,
          isDestination: 0,
          activities: [],
          agriDelivery: del,
        });
      }
    });

    return list;
  }, [
    stopSummary,
    overallSummaryForTrip?.agriDeliveries,
    currentStop?.stopId,
  ]);

  const getFilteredActivities = (activities) => {
    const activitiesList = activities || [];
    if (currentStop.isOrigin) {
      return activitiesList.filter((item) => item.isOrigin);
    }

    if (currentStop.isDestination) {
      return activitiesList.filter((item) => item.isDestination);
    }

    return activitiesList;
  };

  useEffect(() => {
    dispatch(
      getStopSummary({
        stopId: currentStop.stopId,
        tripId: currentStop.tripId,
      }),
    );
  }, [dispatch, currentStop]);

  useEffect(() => {
    const tripTimer = setTimeout(() => {
      dispatch(
        updateTrips({
          key: "toastMessage",
          value: { ...toastMessage, visible: false },
        }),
      );
    }, 5000);

    return () => clearTimeout(tripTimer);
  }, [dispatch, toastMessage]);

  return (
    <div className="p-6 bg-background-white h-[calc(100vh-128px)] overflow-y-scroll">
      {combinedStopSummary?.length ? (
        !combinedStopSummary[0].isOrigin &&
        !combinedStopSummary[0].isDestination && (
          <p className="font-poppins text-xs font-medium mb-4">
            {combinedStopSummary.length === 1
              ? "1 Farmer"
              : `${combinedStopSummary.length} Farmers`}
          </p>
        )
      ) : (
        <p className="font-poppins text-xs font-medium mb-4">
          No activity exists for this stop
        </p>
      )}
      <div className="flex flex-wrap gap-4 w-full">
        {combinedStopSummary?.map((item, index) => (
          <FarmerCard
            key={index}
            index={index}
            isOrigin={item.isOrigin}
            isDestination={item.isDestination}
            farmerId={item.farmerId}
            farmerName={item.farmerName}
            farmerStop={item.farmerStop}
            farmerStopName={item.farmerStopName}
            isNewFarmer={item.isNewFarmer}
            activities={getFilteredActivities(item.activities)}
            agriDelivery={item.agriDelivery}
            onOpenEditedWeightModal={(editedItem) =>
              setEditedWeightModal({ visible: true, data: editedItem })
            }
          />
        ))}
      </div>

      <EditedWeightModal
        visible={editedWeightModal.visible}
        data={editedWeightModal.data}
        onCancel={() => setEditedWeightModal({ visible: false, data: null })}
      />

      <ViewReceiptModal
        visible={receiptModal?.visible}
        onCancel={() => {
          dispatch(
            updateTrips({
              key: "receiptModal",
              value: {
                visible: false,
                data: {},
              },
            }),
          );
        }}
      />

      <DeleteFarmerActivityModal
        visible={deleteFarmerActivityModal?.visible}
        onCancel={() =>
          dispatch(
            updateTrips({
              key: "deleteFarmerActivityModal",
              value: { visible: false, data: {} },
            }),
          )
        }
      />

      <div className="fixed z-[2000]">
        <ToastMessageModal
          visible={toastMessage.visible}
          onCancel={() =>
            dispatch(
              updateTrips({
                key: "toastMessage",
                value: { ...toastMessage, visible: false },
              }),
            )
          }
        />
      </div>
    </div>
  );
};

export default StopSummary;
